import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useRef, useState } from "react";
import LoadingSpinner from "@widget/loaders/LoadingSpinner";
const RecaptchaField = ({ siteKey, enabled = true, onChange, onReady }) => {
    const [isLoading, setIsLoading] = useState(true);
    const [scriptLoaded, setScriptLoaded] = useState(false);
    const recaptchaContainerRef = useRef(null);
    const widgetIdRef = useRef(null);
    useEffect(() => {
        if (!enabled || !siteKey)
            return;
        // Check if script already loaded
        if (window.grecaptcha) {
            setScriptLoaded(true);
            renderRecaptcha();
            return;
        }
        // Define callback for when recaptcha loads
        window.onRecaptchaCallback = () => {
            setScriptLoaded(true);
        };
        // Load the script if not already present
        const existingScript = document.querySelector('script[src*="recaptcha/api.js"]');
        if (!existingScript) {
            const script = document.createElement('script');
            script.src = 'https://www.google.com/recaptcha/api.js?onload=onRecaptchaCallback&render=explicit';
            script.async = true;
            document.head.appendChild(script);
        }
        // Cleanup
        return () => {
            if (widgetIdRef.current !== null && window.grecaptcha) {
                try {
                    window.grecaptcha.reset(widgetIdRef.current);
                }
                catch (e) {
                    // Ignore cleanup errors
                }
            }
        };
    }, [enabled, siteKey]);
    useEffect(() => {
        if (scriptLoaded && enabled && siteKey) {
            renderRecaptcha();
        }
    }, [scriptLoaded, enabled, siteKey]);
    const renderRecaptcha = () => {
        if (window.grecaptcha && recaptchaContainerRef.current) {
            try {
                // Reset existing widget if any
                if (widgetIdRef.current !== null) {
                    window.grecaptcha.reset(widgetIdRef.current);
                }
                // Render new widget
                widgetIdRef.current = window.grecaptcha.render(recaptchaContainerRef.current, {
                    sitekey: siteKey,
                    callback: (response) => {
                        onChange(response);
                    },
                    'expired-callback': () => {
                        onChange('');
                    }
                });
                // Widget rendered successfully
                setIsLoading(false);
                if (onReady) {
                    onReady();
                }
            }
            catch (e) {
                console.error('reCAPTCHA render error:', e);
                setIsLoading(false);
            }
        }
    };
    if (!enabled || !siteKey) {
        return null;
    }
    return (_jsxs("div", { className: `uxpcore_recaptcha-field ${isLoading ? 'uxpcore_recaptcha-field--loading' : ''}`, children: [isLoading && _jsx(LoadingSpinner, { message: "Loading reCAPTCHA..." }), _jsx("div", { ref: recaptchaContainerRef, className: `uxpcore_recaptcha-field__container ${isLoading ? 'uxpcore_recaptcha-field__container--hidden' : ''}` })] }));
};
export default RecaptchaField;
